const commonUtility = require('../domain/commonUtility');
const dateUtil = require('./dateUtil');
const stringUtil = require('../string/stringUtil');

module.exports.getTodayBusinessDate = function ()
{
    const localNow = dateUtil.convertToLocalStandard(dateUtil.getNow());
    const localDate = dateUtil.getDateComponent(localNow);

    const openingTime = !stringUtil.isStringNullOrEmpty(commonUtility.getPropertyOperatingConfiguration().operatingHours) ? 
                                                        commonUtility.getPropertyOperatingConfiguration().operatingHours : "06:00:00";
    
    const openingDateTime = `${localDate} ${openingTime}`;
    if (dateUtil.isSameOrAfter(localNow, openingDateTime))
    {
        return localDate;
    }

    return dateUtil.subtractDays(localDate, 1);
}

module.exports.getPropertyBusinessDateFromUtcDateTime = function(utcDateTime)
{
    const localDateTime = dateUtil.convertToLocalStandard(utcDateTime);
    const localDate = dateUtil.getDateComponent(localDateTime);
    
    const openingTime = !stringUtil.isStringNullOrEmpty(commonUtility.getPropertyOperatingConfiguration().operatingHours) ? 
                                                        commonUtility.getPropertyOperatingConfiguration().operatingHours : "06:00:00";

    const openingDateTime = `${localDate} ${openingTime}`;
    if (dateUtil.isSameOrAfter(localDateTime, openingDateTime))
    {
        return localDate;
    }

    return dateUtil.subtractDays(localDate, 1);
}

module.exports.isDateSameAsTodayBusinessDate = function (date)
{
    return dateUtil.isSame(date, this.getTodayBusinessDate());
}
